import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { TraceInteractionView } from "./TraceInteractionView";

interface TraceInteractionsProps {
  trace: Record<string, any> | null;
  onViewJsonTrace: () => void;
}

function hasStructuredContent(t: Record<string, any> | null): boolean {
  if (!t) return false;
  return (
    !!t?.agent_instance_by_id ||
    (Array.isArray(t?.agents) && t.agents.length > 0) ||
    (Array.isArray(t?.messages) && t.messages.length > 0) ||
    (t?.id != null &&
      t?.name != null &&
      Array.isArray(t?.interactions) &&
      t.interactions.length > 0)
  );
}

export function TraceInteractions({ trace, onViewJsonTrace }: TraceInteractionsProps) {
  const hasContent = hasStructuredContent(trace);

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <DocumentTextIcon className="w-4 h-4 text-muted-foreground" />
          Interactions
        </h3>
        <button
          onClick={onViewJsonTrace}
          className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-muted-foreground bg-muted hover:bg-accent rounded-md transition-colors"
        >
          <span className="font-mono text-xs">{"{}"}</span>
          View JSON Trace
        </button>
      </div>

      {hasContent ? (
        <div className="space-y-4">
          <TraceInteractionView trace={trace!} />
        </div>
      ) : (
        <div className="py-8 text-center">
          <p className="text-sm text-muted-foreground mb-3">
            No structured interactions to display.
          </p>
          <button
            onClick={onViewJsonTrace}
            className="text-sm text-primary hover:text-primary/80 font-medium"
          >
            View raw JSON trace →
          </button>
        </div>
      )}
    </div>
  );
}
